import React, { useState } from "react";
import ReReSubject from "./ReReSubject";

function ReWriteExam(props) {
  const {
    formik,
    setparentSubjectReWriteLength,
    parentSubjectReWriteLength,
    reRegSubject,
  } = props;

  const [fields, setFields] = useState([{ subject: "" }]);

  function handleAdd() {
    const values = [...fields];
    values.push({ subject: "" });
    setFields(values);
    props.setparentSubjectReWriteLength(values);
  }

  function handleRemove(i) {
    const values = [...fields];
    values.splice(i, 1);
    setFields(values);
    props.setparentSubjectReWriteLength(values);
  }

  function handleSubjectChange(i, event) {
    const values = [...fields];
    values[i].subject = event.target.value;
    setFields(values);
    props.setparentSubjectReWriteLength(values);
  }

  return (
    <>
      {formik.values.subjectReWrite_.map((item, idx) => (
        <React.Fragment>
          <div className="row">
            <div className="col-sm-6">
              <select
                className="form-control"
                name={`subjectReWrite_[${idx}].subject`}
                onChange={(e) => handleSubjectChange(idx, e)}
                onBlur={formik.handleBlur}
                key={idx}
                value={formik.values.subjectReWrite_[idx].subject}
                disabled="disabled"
              >
                <option value="">---</option>
                <ReReSubject reRegSubject={reRegSubject} />
              </select>

              {formik.touched.subjectReWrite_ &&
              formik.errors.subjectReWrite_ &&
              formik.touched.subjectReWrite_[idx] &&
              formik.errors.subjectReWrite_[idx] &&
              formik.touched.subjectReWrite_[idx].subject &&
              formik.errors.subjectReWrite_[idx].subject ? (
                <div className="invalid-feedback" style={{ display: "block" }}>
                  {formik.errors.subjectReWrite_[idx].subject}
                </div>
              ) : null}
            </div>
            {/* <div className="col pl-0">
              <a
                href
                className="btn btn-danger"
                onClick={() => handleRemove(idx)}
              >
                <i className="fal fa-trash-alt"></i>
              </a>
            </div> */}
          </div>
        </React.Fragment>
      ))}
      {/* <React.Fragment>
        <div className="form-group m-0">
          <a
            href
            className="btn btn-link p-0 btn-additional"
            onClick={() => handleAdd()}
          >
            <i className="fal fa-plus"></i> Add additional line item
          </a>
        </div>
      </React.Fragment> */}
    </>
  );
}

export default ReWriteExam;
